import { graphql } from 'react-apollo';
import { GetUser } from '../queries/user';
import user from '../resolvers/user';

export const withUser = graphql(GetUser, {
  props: (props: any) => ({
    user: props.data.user || user.defaults.user,
  }),
});



// WEBPACK FOOTER //
// ./src/helpers/withUser.tsx